// tslint:disable
import { call } from 'services/api-service'

/**
 * This is called when coming from a successful inbox submission
 *
 * @method
 * @name ApiService#checkSellerRatingEligibile
 * @param {string} contextToken -
 * @param {number} lastSeenSrDate - Last seen seller rating date in milliseconds UTC
 */
function checkSellerRatingEligibile(parameters: {
  'context-token': string
  lastSeenSrDate?: number
}): Promise<{
  transactionId?: number
}> {
  return call<{
    transactionId?: number
  }>(
    'GET',
    '/{siteKey}/sellerRating/checkEligible',
    parameters,
    ['context-token'],
    ['lastSeenSrDate'],
    ['context-token']
  )
}

export default { checkSellerRatingEligibile }
